module.exports = __webpack_public_path__ + "static/media/ipos.c6aa8d9e.svg";